import Sidebar from "../../../components/side-bar/sidebar";
import TCHeader from "./tc-header";
import AccessControlWrapper from "components/access-control/AccessControlWrapper";
import { accessEnum } from "components/access-control/accessEnum";
import NexaLauncher from "pages/nexa-ai/NexaLauncher";

export default function TCLayout({ children, heading, isEmbed = false }) {
  if (isEmbed)
    return (
      <div className="tw-w-full">
        <nav className={`tw-flex tw-items-center tw-justify-between tw-fixed tw-top-0 !tw-bg-white tw-border-b tw-border-[#e7e7e7] tw-h-12 !tw-z-[1000] !tw-px-3 tw-min-w-full`}>
          <div className="tw-text-label-lg tw-font-medium">{heading || ""}</div>
          <img src="https://res.cloudinary.com/drzta9shk/image/upload/q_auto:eco/v1645184218/global/trademo_logo/Footer_Black_logo_dfabjp.svg" alt="trademo logo" height={20} />
        </nav>
        <div className="tw-mt-12 tw-p-5">{children}</div>
      </div>
    );
  return (
    <>
      <TCHeader heading={heading} />
      <Sidebar>{children}</Sidebar>
      <AccessControlWrapper permissionKey={accessEnum.NEXA_AI_MODULE_ACCESS}>
        <NexaLauncher />
      </AccessControlWrapper>
    </>
  );
}
